export default __webpack_public_path__ + "static/media/SHREYANSH.9c96ff6d.jpeg";